import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { AngleDownIcon, AngleUpIcon, AttachFileIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * クライアント：共有済み資料の表示切り替えを行うためのボタン
 * @param props
 * @constructor
 */
export const FileShareToggleButton = (props) => {
    const { className = '', count = 0, id, isOpen, onClick } = props;
    return (_jsx("button", Object.assign({ className: clsx('group', className), onClick: onClick, type: 'button', value: id }, { children: _jsxs(IconTextGroup, { children: [_jsx(AttachFileIcon, { color: 'info', size: 'sm' }), _jsx(Text, Object.assign({ className: clsx('group-hover:text-link', 'whitespace-nowrap'), color: 'base', isBold: true, size: 'xs' }, { children: `共有済${count > 0 ? `(${count})` : ''}` })), isOpen ? (_jsx(AngleUpIcon, { className: clsx('group-hover:text-turquoise-blue-100'), color: 'base', size: 'sm' })) : (_jsx(AngleDownIcon, { className: clsx('group-hover:text-turquoise-blue-100'), color: 'base', size: 'sm' }))] }) })));
};
